import { Badges, H5, LI, SVG } from "../../../../AbstractElements";
import { Notification } from "../../../../utils/Constant";
import NotificationBox from "./NotificationBox";

const Notifications = () => {
  return (
    <LI className="onhover-dropdown">
      <div className="notification-box">
        <SVG iconId="notification" />
        <Badges pill color="primary">4 </Badges>
      </div>
      <div className="onhover-show-div notification-dropdown">
        <H5 className="f-18 f-w-600 mb-0 dropdown-title">{Notification} </H5>
        <NotificationBox />
      </div>
    </LI>
  );
};

export default Notifications;
